module.exports = __webpack_public_path__ + "img/DSC_1154.0794d648.jpg";